<template>
  <div>
    <Closingstatement
      style="background: #fff"
      ref="finalClo"
      :myArrayProp2="myArrayProp"
      :iid="iid"
      :isDownPdf="isDownPdf"
    ></Closingstatement>
<!-- 
    <div
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: center"
    >
      <el-button type="primary" @click="getWord" class="AllDialogBtn"
        >下载表格</el-button
      >
    </div> -->
  </div>
</template>

<script>
import Closingstatement from "../components/Closingstatement.vue";
//下载pdf
import { downloadPDF } from "@/components/tool/pdf";
export default {
  components: { Closingstatement },
  data() {
    return {
      myArrayProp: [], //结项书-后端获取的数据
      iid: this.$route.query.iid,
      isDownPdf: true,
      submitData: {
        //结项书要填写的数据
        brief: "",
        plan: "",
        technology: "",
        business: "",
        innovate: "",
        resultAccessory: [],
        firmAccessory: [],
        competitionAccessory: [],
        exchangeAccessory: [],
        conversionAccessory: [],
        talentsAccessory: [],
        targetPlan: "",
        realityResult: "",
        socialValue: "",
        taskAccessory: [],
      },
    };
  },
  methods: {
    getPrice() {
      this.ajax
        .get(this.$store.state.api + "/getClosingstatementData", {
          uid: this.$store.state.userInfo.userid,
          pid: this.iid,
        })
        .then((res) => {
          let num = 0;
          res.data[1].forEach((i) => {
            //计算出已经使用过的金钱
            // console.log(i);
            i["actualuse"] = JSON.parse(i["actualuse"]);
            for (let key in i["actualuse"]) {
              if (i["actualuse"][key]) {
                num = i["actualuse"][key] * 1 + num;
              }
            }
          });
          console.log(num);

          let data = res.data[0];

          data[0].course_student = JSON.parse(data[0].course_student);
          data[0].course_teacher = JSON.parse(data[0].course_teacher);
          if (data[0].multiSelectProject != null) {
            data[0].multiSelectProject = JSON.parse(data[0].multiSelectProject);
          }

          data[0].money = JSON.parse(data[0].money);
          data[0].ClosingstatementData = data[0].ClosingstatementData
            ? JSON.parse(data[0].ClosingstatementData)
            : this.submitData;

          this.myArrayProp = data;
          this.myArrayProp[0].actualuse = num; //添加已经使用过的经费

          console.log(this.myArrayProp);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWord() {
      this.isDownPdf = true;
      this.$forceUpdate();
      setTimeout(() => {
        downloadPDF(
          this.$refs.finalClo.$refs.downPDF,
          this.myArrayProp[0].title + "申报书"
        );
        setTimeout(() => {
          this.isDownPdf = false;
          this.$forceUpdate();
        }, 500);
      }, 500);
    },
  },

  mounted() {
    // console.log(this.myArrayProp);
    //    this.getData();
    this.getPrice();
  },
};
</script>

<style lang="less" scoped>
</style>